import React, { useEffect, useState } from 'react'

import WhyChooseSection from '../site/components/WhyChooseSection/WhyChooseSection';
import OurServicesSection from '../site/components/OurServicesSection/OurServicesSection';
import WhatsetsApartSection from '../site/components/WhatSetsApartSection/WhatsetsApartSection';
import WhenConsultSection from '../site/components/WhenConsultSection/WhenConsultSection';

import Icon1 from '../site/assets/images/Patient-CenteredCare.svg';
import Icon2 from '../site/assets/images/AdvancedDiagnosticTechnology.svg';
import Icon3 from '../site/assets/images/MinimallyInvasiveTechnique.svg';
import Icon4 from '../assets/images/ComprehensiveRehabilitation.svg';
import Icon5 from '../assets/images/AffordableOrthopedicIcon.svg';

import ConditionIcon1 from '../assets/images/Osteoarthritis.svg';
import ConditionIcon2 from '../assets/images/RheumatoidArthritis.svg';
import ConditionIcon3 from '../assets/images/HipFractures.svg';
import ConditionIcon4 from '../assets/images/KneePainandDegeneration.svg';
import ConditionIcon5 from '../assets/images/SpinalDisorders.svg';
import ConditionIcon6 from '../assets/images/SportsInjuries.svg';
import ConditionIcon7 from '../assets/images/BoneFracturesDislocations.svg';
import ConditionIcon8 from '../assets/images/Tendonitis.svg';
import ConditionIcon9 from '../assets/images/CarpalTunnelSyndrome.svg';
import ConditionIcon10 from '../assets/images/ShoulderImpingement.svg';
import ConditionIcon11 from '../assets/images/JointInstability.svg';
import ConditionIcon12 from '../assets/images/GoutConditions.svg';
import ConditionIcon13 from '../assets/images/PediatricOrthopedicIssues.svg';
import ConditionIcon14 from '../assets/images/AmputationsLoss.svg';
import ConditionIcon15 from '../site/assets/images/icons/FractureCareManagement.svg';


import ConditionsTreatSection from '../site/components/ConditionsTreatSection/ConditionsTreatSection';
import FaqSection from '../site/components/FaqSection/FaqSection';
import PatientSuccessStories from '../site/components/PatientsSuccessStorySection/PatientSuccessStories';
import LokmanyaNetwork from '../site/components/LokmanyaNetworkSection/LokmanyaNetwork';
import { CommonBanner } from '../site/components';
import BannerImg from "../site/assets/images/varicose-vein/varicose-vein-banner.webp";
import Head from 'next/head';
import { useRouter } from 'next/router';
import { getSpecialityDoctors } from '@/ApiActions/CommonApi';
import MeetOurExpertSpeciality from '@/site/components/MeetOurExpertSpeciality';


const WhyChooseData = {
  title: "Why Choose Lokmanya Hospitals for Vascular Surgery Care?",
  items: [
    {
      title: 'Comprehensive Vascular Care',
      description: 'We offer a full spectrum of treatments for venous disorders — from conservative management and compression therapy to advanced laser ablation and surgical procedures — all under one roof.',
      image: "/images/specialities-images/varicose-vein/comprehensive-vascular-care.webp",
    },
    {
      title: 'Expert Team of Vascular Surgeons',
      description: 'Our vascular surgeons and interventional radiologists bring extensive experience in diagnosing and treating a wide range of venous conditions, ensuring that every patient receives the most precise, effective, and evidence-based care available.',
      image: "/images/specialities-images/Orthopedics/ExpertTeamortho.jpg",
    }, 
    {
      title: 'Personalized Treatment Plans',
      description: 'We believe in tailoring care to each individual. After a thorough duplex ultrasound evaluation, our specialists design a customized treatment plan - whether minimally invasive, non-surgical, or a combined approach - that aligns with your specific condition and lifestyle.',
      image: "/images/specialities-images/varicose-vein/personalized-treatment-plans.webp",
    },
    {
      title: 'Affordable and Accessible',
      description: 'At Lokmanya Hospitals, we are committed to making high-quality Vascular Surgery treatment accessible to all patients, offering cost-effective solutions with cashless insurance and EMI options, without any compromise on clinical excellence.',
      image: "/images/specialities-images/Affordable.webp",
    },
    {
      title: 'Unmatched Procedural Expertise',
      description: 'With an impressive record of thousands of successful vein procedures - including Endovenous Laser Ablation (EVLA), Radiofrequency Ablation (RFA), VenaSeal glue therapy, and sclerotherapy - our specialists deliver precision, safety, and superior outcomes for every patient.',
      image: "/images/specialities-images/varicose-vein/unmatched-procedural-expertise.webp",
    },
  ]
};

const serviceData = {
  title: "Our Vascular Surgery Services",
  items: [
    {
      title: "Endovenous Laser Ablation (EVLA)",
      description: "A gold-standard, minimally invasive laser procedure that seals diseased veins from within using targeted laser energy. Virtually painless, scar-free, and same-day discharge with rapid recovery.",
      imageUrl: "/images/specialities-images/varicose-vein/endovenous-laser-ablation.webp",
    },
    {
      title: "Radiofrequency Ablation (RFA)",
      description: "A modern, catheter-based technique that uses controlled radiofrequency heat energy to close and collapse damaged veins. Highly effective with minimal downtime and excellent long-term results.",
      imageUrl: "/images/specialities-images/varicose-vein/radiofrequency-ablation.webp",
    },
    {
      title: "Sclerotherapy",
      description: "A proven injection-based treatment that causes problem veins to shrink and fade. Particularly effective for spider veins and smaller reticular veins, restoring smooth, clear skin on the legs.",
      imageUrl: "/images/specialities-images/varicose-vein/sclerotherapy.webp",
    },
    {
      title: "VenaSeal Glue Therapy",
      description: "An advanced, non-thermal procedure using a medical-grade adhesive to seal diseased veins permanently. No heat, no needles in multiple places, and no compression stockings required post-procedure.",
      imageUrl: "/images/specialities-images/varicose-vein/venaseal-glue-therapy.webp",
    },
    {
      title: "Ambulatory Phlebectomy",
      description: "A micro-surgical technique that removes bulging surface Vascular Surgery through tiny skin punctures, leaving no visible scarring. Performed under local anaesthesia with immediate walking post-procedure.",
      imageUrl: "/images/specialities-images/varicose-vein/ambulatory-phlebectomy.webp",
    },
    {
      title: "Duplex Ultrasound-Guided Treatment",
      description: "Every treatment at our centre begins with a comprehensive colour duplex ultrasound mapping to precisely identify diseased vein segments, ensuring accurate and targeted intervention every time.",
      imageUrl: "/images/specialities-images/varicose-vein/duplex-ultrasound-guided-treatment.webp",
    },
    {
      title: "Leg Ulcer & Wound Care",
      description: "Our specialists provide integrated care for venous leg ulcers - a complication of untreated Vascular Surgery - combining advanced wound management with definitive vascular correction for lasting healing.",
      imageUrl: "/images/specialities-images/varicose-vein/leg-ulcer.webp",
    },
    // {
    //   title: "Orthotic and Prosthetic Services",
    //   description: "We offer customized orthotic devices and prosthetics to improve mobility and functionality for patients with amputations or chronic conditions.",
    //   imageUrl: img8,
    // }
  ]
};

const whatsetsApartdata = {
  title: "Vascular Surgery Care at Lokmanya Hospitals – What Sets Us Apart?",
  items: [
    {
      title: "Patient-Centered Vascular Care",
      description: "Every patient at Lokmanya Hospitals receives a personalised consultation, accurate duplex ultrasound evaluation, and a treatment plan designed exclusively around their clinical condition and personal goals.",
      icon: Icon1,
    },
    {
      title: "Advanced Diagnostic Technology",
      description: "Early and accurate diagnosis drives effective treatment. Our digital duplex ultrasound systems and Doppler imaging tools allow our specialists to map venous reflux patterns precisely, enabling targeted and effective interventions.",
      icon: Icon2,
    },
    {
      title: "Minimally Invasive Techniques",
      description: "We prioritize walk-in, walk-out procedures using laser ablation, RFA, VenaSeal, and foam sclerotherapy - ensuring minimal pain, no hospital stay, no visible scarring, and a rapid return to daily activities.",
      icon: Icon3,
    },
    {
      title: "Comprehensive Post-Treatment Rehabilitation",
      description: "Recovery is as important as treatment. Our post-procedure care includes structured compression therapy, physiotherapy-guided exercises, regular follow-up duplex ultrasound, and dietary and lifestyle counselling to prevent recurrence.",
      icon: Icon4,
    },
    {
      title: "Affordable Vascular Surgery Treatment in Pune",
      description: "At Lokmanya Hospitals, we ensure that world-class vascular care remains within reach for all patients - with transparent pricing, insurance tie-ups, and flexible EMI options that make quality treatment stress-free.",
      icon: Icon5,
    }, 
  ]
};

const consultationData = {
  title: "When to Consult a Doctor For Vascular Surgery Issues?",
  items: [
    {
      title: "Visible Bulging or Twisted Veins",
      description: "If you notice ropy, twisted, blue or dark purple veins on your legs or calves that are becoming more prominent, it is time to consult a vascular specialist.",
      image: "/images/specialities-images/varicose-vein/visible-bulging.webp",
    },
    {
      title: "Persistent Leg Heaviness or Aching",
      description: "A constant feeling of heaviness, tiredness, or dull aching in the legs - especially after prolonged standing or sitting - is an early warning sign of underlying venous disease.",
      image: "/images/specialities-images/varicose-vein/persistent-leg-heaviness.webp",
    },
    {
      title: "Leg Swelling by End of Day",
      description: "Swelling around the ankles and lower legs that appears or worsens towards the evening indicates poor venous return and should be medically evaluated without delay.",
      image: "/images/specialities-images/varicose-vein/leg-swelling.webp",
    },
    {
      title: "Skin Changes Around the Ankle",
      description: "Darkening of the skin, eczema, or thickening of the skin around the ankles is signs of chronic venous insufficiency requiring immediate specialist assessment.",
      image: "/images/specialities-images/varicose-vein/skin-changes-around-the-ankle.webp",
    },
    {
      title: "Recurring Leg Cramps or Restlessness",
      description: "Frequent night cramps, a restless leg sensation, or itching over bulging veins may indicate venous hypertension and benefit from early vascular intervention.",
      image: "/images/specialities-images/varicose-vein/recurring-leg-cramps.webp",
    },
    {
      title: "Non-Healing Wounds or Ulcers on Legs",
      description: "Open wounds or ulcers near the ankle or lower leg that refuse to heal are a serious complication of untreated Vascular Surgery and require urgent vascular care.",
      image: "/images/specialities-images/varicose-vein/ulcers-on-legs.webp",
    }
  ]
};

 

const faqs = [
  {
    question: "Are Vascular Surgery treatments painful? ",
    answer: "Modern minimally invasive procedures like EVLA and RFA are performed under local anaesthesia and cause minimal discomfort. Most patients walk in and walk out the same day with little to no pain during or after the procedure.",
  },
  {
    question: "How long does recovery take after Vascular Surgery treatment?",
    answer: "Recovery after laser or RFA treatment is typically swift — most patients resume light daily activity within 24–48 hours. Compression stockings are recommended for 1–2 weeks for optimal results.",
  },
  {
    question: "Do Vascular Surgery come back after treatment?",
    answer: "With accurate duplex ultrasound mapping and precise treatment, recurrence rates are very low. Lifestyle modifications - including regular walking, weight management, and compression therapy - further reduce the chance of new vein formation.",
  },
  {
    question: "Is Vascular Surgery treatment covered under insurance? ",
    answer: "Yes, most Vascular Surgery procedures are covered under health insurance when the condition causes clinical symptoms. Our team assists patients with cashless insurance claims and pre-authorisation documentation.",
  }
];
function Service() {

  
  const router = useRouter();
     const slug = router.pathname;
     const [doctorData, setData] = useState([]);
     useEffect(() => {
         if (!slug || slug.length === 0) return;
 
         const fullSlug = (Array.isArray(slug) ? slug.join('/') : slug).replace(/^\/+/, '');
         const fetchDoctors = async () => {
             try {
                 const response = await getSpecialityDoctors(fullSlug);
                 if (!response?.data || response.data.length === 0) {
                     return;
                 }
 
                 setData(response.data); // set fetched data
             } catch (error) {
                 console.error("Failed to fetch doctors:", error);
             }
         };
 
         fetchDoctors();
     }, [slug]);

  return (
    <>
      <Head>
        <title>Vascular Surgery Treatment Hospital in Pune | Lokmanya Hospitals</title>
        <meta name="description" content="Lokmanya Hospital, the Vascular Surgery Treatment Hospital in Pune​" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Hospital",
            "name": "Lokmanya Hospital",
            "url": "https://www.lokmanyahospitals.com/varicose-vein",
            "description": "Lokmanya Hospitals offers advanced Vascular Surgery treatment in Pune — laser ablation, sclerotherapy, VenaSeal & minimally invasive procedures by expert vascular surgeons.",
            "medicalSpecialty": "Vascular Surgery",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "402/A Gokhale Nagar Road, Vetal Baba Chowk, off Senapati Bapat, Pune, Maharashtra 411016",
              "addressLocality": "Pune",
              "addressRegion": "Maharashtra",
              "postalCode": "411016",
              "addressCountry": "IN"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-72-1934-3223",
              "contactType": "Customer Service",
              "email": "care@lokmanyahospitals.com"
            }
          })}
        </script>
      </Head>
      <div>
        <section>
          <CommonBanner bgColor={"#EFEDD1"} bgImage={BannerImg.src}>
            <div className="header-section">
              <h1 className="page-heading">Vascular Surgery</h1>
              <p className="subtitle">
                Lokmanya Hospitals is renowned for its skilled and knowledgeable vein specialists who utilize state-of-the-art minimally invasive technology for Vascular Surgery treatment. We prioritize patient comfort by offering "walk-in, walk-out" procedures that eliminate the need for long hospital stays.  
Our advanced approach ensures a nearly painless experience, allowing you to get back on your feet and regain your leg health immediately.

              </p>
            </div>
          </CommonBanner>
          <div className="overview-section side-space section-space">
            <h2 className="page-heading">Overview</h2>
            <div className="para">
              <p> Lokmanya Hospitals is a trusted name for Vascular Surgery treatment in Pune, providing a complete range of vascular care solutions designed to address venous disorders at every stage. Our dedicated vascular surgery department is equipped with state-of-the-art diagnostic and treatment technology, supported by a team of expert vascular surgeons and interventional specialists committed to patient wellness at every age.</p>
              <p>From mild spider veins and cosmetic concerns to advanced chronic venous insufficiency, deep vein thrombosis, and non-healing leg ulcers, we offer comprehensive, individualized treatment approaches. Whether you require minimally invasive laser therapy, sclerotherapy, or surgical intervention, our team is here to guide you through every step of your diagnosis, treatment, and recovery journey.</p>
            </div>
          </div>
        </section>
        <WhyChooseSection data={WhyChooseData} />
        <OurServicesSection data={serviceData} />
        {doctorData && doctorData.length > 0 && (
          <MeetOurExpertSpeciality data={doctorData} />
        )}
        <WhatsetsApartSection data={whatsetsApartdata} />
        <WhenConsultSection data={consultationData} />
         
        <FaqSection data={faqs} />
        {/* <DiagnosisTreatment /> */}
        {/* <OrthopedicExperts/> */}
        {/* <ExploreExpert/> */}
        <PatientSuccessStories />
        <LokmanyaNetwork />
      </div >
    </>
  )
}

export default Service
